export { ZLabComponent } from './z-lab.component';
export type { ZLabParams } from './z-lab.component';
export * from './z-lab.presets';
